


























import {
  computed,
  defineNuxtComponent,
  vue3Model,
  ref
} from '~/utils/nuxt3-migration'
import { defineComponentTranslations } from '~/utils/i18n'
import CDropdown from '~/components/shared/configurable/dropdown/CDropdown.vue'

export default defineNuxtComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const dropdownRef = ref<InstanceType<typeof CDropdown> | null>(null)

    const isShown = computed({
      get() {
        return props.modelValue
      },
      set(value: boolean) {
        emit('update:modelValue', value)
      }
    })

    return {
      dropdownRef,
      isShown
    }
  },
  i18n: defineComponentTranslations({
    not_enough_credits_for_this_action: {
      en: "You don't have enough credits for this action",
      el: 'Τα credits σου δεν επαρκούν για αυτή την ενέργεια'
    }
  })
})
